import { render, staticRenderFns } from "./PositionsPercentDiff.vue?vue&type=template&id=852ffd6c&"
import script from "./PositionsPercentDiff.vue?vue&type=script&lang=js&"
export * from "./PositionsPercentDiff.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports